
import Vehicle from './Vehicle'
import VehicleType from './VehicleType'
import User from './User'
import Step from './Step'

export default

    class VehicleRequest {
    constructor(created_date = "", begin_date = "", end_date = "", 
        type_vehicle_id = 0, step_id = 0, user_id = 0, client_id = 0, driver_id = 0,
        vehicle_odometer = 0, transaction_id="", beginOdometer = null, endOdometer = null,
        coupon_id = null, card_id = null) {

        this.created_date = created_date
        this.begin_date = begin_date
        this.end_date = end_date
        this.type_vehicle_id = type_vehicle_id
        this.step_id = step_id
        this.user_id = user_id
        this.client_id = client_id
        this.driver_id = driver_id
        this.vehicle = new Vehicle()
        this.typeVehicle = new VehicleType()
        this.user = new User()
        this.step = new Step()
        this.Vehicle = new Vehicle()
        this.vehicle_odometer = vehicle_odometer
        this.transaction_id = transaction_id
        this.beginOdometer = beginOdometer
        this.endOdometer = endOdometer
        this.coupon_id = coupon_id
        this.card_id = card_id
    }
}